import { MenuItem } from './menu-item';

export const MAIN_MENU_CONFIG: MenuItem[] = [
  // Shipment items - hidden for admin users
  {
    title: 'Create new shipment',
    icon: 'add_box',
    route: 'shipments/create',
    hideForAdmin: true,
  },
  {
    title: 'Shipment list',
    icon: 'package_2',
    route: 'shipments/list',
    hideForAdmin: true,
  },
  // Admin items - only visible for admin users
  {
    title: 'Users',
    icon: 'group',
    route: 'admin/users',
    adminOnly: true,
  },
  {
    title: 'Tenants',
    icon: 'business',
    route: 'admin/tenants',
    adminOnly: true,
  },
  {
    title: 'Shipments',
    icon: 'package_2',
    route: 'admin/shipments',
    adminOnly: true,
  },
  {
    title: 'Error Logs',
    icon: 'error_outline',
    route: 'admin/error-logs',
    adminOnly: true,
  },
];
